/**
 * Resolves the icon/label to show for a conversation's *origin*. When the
 * conversation carries a portal `source` (e.g. AGENT_PORTAL from the agent
 * portal create flow) we show that; otherwise we fall back to the transport
 * channel (email/whatsapp/…). Mirrors the KC2 reference, which shows a distinct
 * source icon per interaction rather than only the raw channel.
 */
import { Globe, Headset, Phone, User } from 'lucide-react'
import { getChannelConfig, type ChannelConfig } from '../../../modules/conversations/channelConfig.js'

const SOURCE_CONFIG: Record<string, ChannelConfig> = {
  AGENT_PORTAL: { icon: Headset, label: 'Agent Portal', color: 'text-indigo-600', bg: 'bg-indigo-50' },
  AGENTPORTAL: { icon: Headset, label: 'Agent Portal', color: 'text-indigo-600', bg: 'bg-indigo-50' },
  CLIENT_PORTAL: { icon: Globe, label: 'Client Portal', color: 'text-indigo-500', bg: 'bg-indigo-50' },
  CLIENTPORTAL: { icon: Globe, label: 'Client Portal', color: 'text-indigo-500', bg: 'bg-indigo-50' },
  WEB: { icon: Globe, label: 'Web', color: 'text-orange-600', bg: 'bg-orange-50' },
  WALKIN: { icon: User, label: 'Walk-in', color: 'text-teal-600', bg: 'bg-teal-50' },
  CALL: { icon: Phone, label: 'Call', color: 'text-orange-600', bg: 'bg-orange-50' },
}

/** Origin config: portal source takes priority, else the channel. */
export function getOriginConfig(source: string | null, channelOrigin: string): ChannelConfig {
  if (source) {
    const key = source.toUpperCase()
    if (SOURCE_CONFIG[key]) return SOURCE_CONFIG[key]!
  }
  return getChannelConfig(channelOrigin)
}
